'use client'

import { useContext } from 'react'
import { ReturnsInfoContext } from 'shipping-and-returns/context/ReturnsInfoProvider'

export const useReturnsInfo = () => useContext(ReturnsInfoContext)
